<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button> -->
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-input-group>
            <b-input-group-prepend > 
              <label style="min-width: 150px">Periode</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl2" 
            type="date" class="ml-3" 
            :max="maxdtreport"
            :state="!$v.model.tgl2.$error"></b-form-input>
            <b-input-group-append>
              <b-button
                variant="success"
                @click="getDA()"
                class="ml-3"
              >
                <i class="fa fa-play"></i> Proses
              </b-button>
              <b-button variant="primary ml-2" @click="exportxlsDA()">
                <i class="fa fa-file-excel-o"></i>Export
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :filter="filterInput"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(index)="data">{{((tblData.page-1)*tblData.limit)+( data.index + 1) }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
            data.item.bunga_tarifthn | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(EffectiveRatePercentage)="data">{{
            data.item.EffectiveRatePercentage | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(DaysOverdue)="data">{{
            data.item.DaysOverdue | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket1_gross)="data">{{
            data.item.bucket1_gross | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket1_pokok)="data">{{
            data.item.bucket1_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket2_gross)="data">{{
            data.item.bucket2_gross | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket2_pokok)="data">{{
            data.item.bucket2_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket3_gross)="data">{{
            data.item.bucket3_gross | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket3_pokok)="data">{{
            data.item.bucket3_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(principal_outstand)="data">{{
            data.item.principal_outstand | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket4_gross)="data">{{
            data.item.bucket4_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(saldo_interest)="data">{{
            data.item.saldo_interest | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket4_pokok)="data">{{
            data.item.bucket4_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket5_gross)="data">{{
            data.item.bucket5_gross | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket5_pokok)="data">{{
            data.item.bucket5_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket6_gross)="data">{{
            data.item.bucket6_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket6_pokok)="data">{{
            data.item.bucket6_pokok | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket7_gross)="data">{{
            data.item.bucket7_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket7_pokok)="data">{{
            data.item.bucket7_pokok | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket8_gross)="data">{{
            data.item.bucket8_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket8_pokok)="data">{{
            data.item.bucket8_pokok | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket9_gross)="data">{{
            data.item.bucket9_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket9_pokok)="data">{{
            data.item.bucket9_pokok | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket10_gross)="data">{{
            data.item.bucket10_gross | numFormat("0,0")
          }}</template>
          <template v-slot:cell(bucket10_pokok)="data">{{
            data.item.bucket10_pokok | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Principal_Amount)="data">{{
            data.item.OS_Principal_Amount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Interest_Amount)="data">{{
            data.item.OS_Interest_Amount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Principal_Undue)="data">{{
            data.item.OS_Principal_Undue | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Interest_Undue)="data">{{
            data.item.OS_Interest_Undue | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Contract_Prepaid_Amt)="data">{{
            data.item.Contract_Prepaid_Amt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(LC_Installment_Amt)="data">{{
            data.item.LC_Installment_Amt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(LC_Installment_Paid)="data">{{
            data.item.LC_Installment_Paid | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Installment_Due_Amt)="data">{{
            data.item.Installment_Due_Amt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Installment_Due_Paid)="data">{{
            data.item.Installment_Due_Paid | numFormat("0,0")
          }}</template>

          <template v-slot:cell(wo_status_date)="data">{{
            data.item.wo_status_date | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NEXT_INST_DT)="data">{{
            data.item.NEXT_INST_DT | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NextInstallmentDueDt)="data">{{
            data.item.NextInstallmentDueDt | moment("DD/MM/YY")
          }}</template>

          <template v-slot:cell(Installment_Due_Off)="data">{{
            data.item.Installment_Due_Off | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Principal_Undue_Off)="data">{{
            data.item.OS_Principal_Undue_Off | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OS_Interest_Undue_Off)="data">{{
            data.item.OS_Interest_Undue_Off | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Installment_Due_Paid_Off)="data">{{
            data.item.Installment_Due_Paid_Off | numFormat("0,0")
          }}</template>
          <template v-slot:cell(FeeChargeRcvAmt)="data">{{
            data.item.FeeChargeRcvAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(FeeChargeRcvPaidAmt)="data">{{
            data.item.FeeChargeRcvPaidAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(NTFAmount)="data">{{
            data.item.NTFAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(InstallmentAmount)="data">{{
            data.item.InstallmentAmount | numFormat("0,0")
          }}</template>

          <template v-slot:cell(LastPaymentDate)="data">{{
            data.item.LastPaymentDate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(OSAR)="data">{{
            data.item.OSAR | numFormat("0,0")
          }}</template>

          <template v-slot:cell(interest)="data">{{
            data.item.interest | numFormat("0,0")
          }}</template>
          <template v-slot:cell(TotalAR)="data">{{
            data.item.TotalAR | numFormat("0,0")
          }}</template>
          <template v-slot:cell(TotalOverdue)="data">{{
            data.item.TotalOverdue | numFormat("0,0")
          }}</template>
          <template v-slot:cell(NextInstallmentAmount)="data">{{
            data.item.NextInstallmentAmount | numFormat("0,0")
          }}</template>

          <template v-slot:cell(NextInstallmentDate)="data">{{
            data.item.NextInstallmentDate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NextInstallmentDueDate)="data">{{
            data.item.NextInstallmentDueDate | moment("DD/MM/YY")
          }}</template>

          <!-- <template v-slot:cell(UCI)="data">{{
            data.item.UCI | numFormat("0,0")
          }}</template> -->
          <template v-slot:cell(UCI_lancar)="data">{{
            data.item.UCI_lancar | numFormat("0,0.00")
          }}</template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>
      <b-row class="m-1">
        <b-col lg="6">
          <b-row v-if="filterShow == 'Hide'">
            <b-input-group size="sm">
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              ></b-form-checkbox>
              <b-input-group-prepend>
                <span class="pr-2">
                  <b> {{ filterShow }}</b> Filter
                </span>
              </b-input-group-prepend>
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <b-input-group size="sm" class="ml-4">
              <b-input-group-prepend class="ml-5">
                <span class="pr-2">On</span>
              </b-input-group-prepend>
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="no_agreement"
                  >Agreement No.</b-form-checkbox
                >
                <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
                <b-form-checkbox value="KOL_EOM"
                  >Collectability</b-form-checkbox
                >
                <b-form-checkbox value="DefaultStat"
                  >Default (WO) status</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-input-group>
            <label class="text-muted small" style="margin-left: 100px"
              >Leave all unchecked to filter on all data</label
            >
          </b-row>
          <b-row v-else>
            <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
            >
              <b> {{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-row>
        </b-col>
        <b-col lg="6">
          <div style="display: flex; margin: 0; padding: 0">
            <div
              style="margin: 0; padding: 5px; width: 500px; text-align: right"
            >
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
              <span v-if="tblData.page * tblData.limit > tblData.total">{{
                tblData.total
              }}</span>
              <span v-else>{{ tblData.page * tblData.limit }}</span> of
              {{ tblData.total }} , <span class="mr-1">limit per page :</span>
              <select v-model="tblData.limit" style="width: 60px">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>40</option>
                <option>50</option>
                <option>60</option>
                <option>70</option>
                <option>80</option>
                <option>90</option>
              </select>
            </div>
            <div>
              <b-pagination
                class="ml-1"
                align="left"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isBusy"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VueMonthlyPicker from 'vue-monthly-picker';

toastr.init();
export default {
  components: { myNumber, VueMonthlyPicker, Loading },
  mixins: [validationMixin],
  validations: {
    model: {
        // periode: { required },
        tgl2:{required}
    },
  },
  data() {
    return {
      maxdtreport : moment(this.$store.state.timeServer).subtract(1,'days').format('YYYY-MM-DD'),
      showFilter: true,
      isBusy: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        date:'',
        
      },
      isLoading:false,
      monthLabels:dropdown.monthLabels,
      model: {tgl1:'',tgl2:moment().endOf('month').format('YYYY-MM-DD'),periode:moment().format('YYYY-MM-DD')},
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: ['no_agreement','CustName'],   
      
    };
  },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "#",
          thStyle: "width:140px",
        },
        {
          key: "no_agreement",
          label: "Agreement No",
          thStyle: "width:140px",
          sortable: true,
      },
      {
          key: "no_kontrak",
          label: "Application No",
          thStyle: "width:140px",
          sortable: true,
      },
      {
          key: "CustCode",
          label: "CIF",
          thStyle: "width:140px",
          sortable: true,
      },
      {
          key: "CustName",
          label: "Debitur Name",
          thStyle: "width:140px",
          sortable: true,
      },
      {
          key: "bunga_tarifthn",
          label: "Effective Rate Percentage",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "DAYS_OVER_DUE",
          label: "Days Overdue",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket1_gross",
          label: "Bucket 1 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket1_pokok",
          label: "Bucket 1 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket2_gross",
          label: "Bucket 2 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket2_pokok",
          label: "Bucket 2 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket3_gross",
          label: "Bucket 3 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket3_pokok",
          label: "Bucket 3 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket4_gross",
          label: "Bucket 4 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket4_pokok",
          label: "Bucket 4 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket5_gross",
          label: "Bucket 5 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket5_pokok",
          label: "Bucket 5 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket6_gross",
          label: "Bucket 6 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket6_pokok",
          label: "Bucket 6 Princple Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket7_gross",
          label: "Bucket 7 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket7_pokok",
          label: "Bucket 7 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket8_gross",
          label: "Bucket 8 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket8_pokok",
          label: "Bucket 8 Princple Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket9_gross",
          label: "Bucket 9 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket9_pokok",
          label: "Bucket 9 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket10_gross",
          label: "Bucket 10 Gross Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "bucket10_pokok",
          label: "Bucket 10 Principle Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Principal_Amount",
          label: "OS Principal Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Interest_Amount",
          label: "OS Interest Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Principal_Undue",
          label: "OS Principal Undue Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Interest_Undue",
          label: "OS Interest Undue Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "Contract_Prepaid_Amt",
          label: "Contract Prepaid Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "LC_Installment_Amt",
          label: "LC Installment Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "LC_Installment_Paid",
          label: "LC Installment Paid Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "Installment_Due_Amt",
          label: "Installment Due Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "Installment_Due_Paid",
          label: "Installment Due Paid Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "wo_status_date",
          label: "WO Dt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentNo",
          label: "Next Installment No",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NEXT_INST_DT",
          label: "Next Installment Dt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NEXT_INST_DUE_NUM",
          label: "Next Installment Due No",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentDueDt",
          label: "Next Installment Due Dt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "DefaultStat",
          label: "Default Stat",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
      },
      {
          key: "Installment_Due_Off",
          label: "Installment Due Off Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Principal_Undue_Off",
          label: "OS Principal Undue Off Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OS_Interest_Undue_Off",
          label: "OS Interest Undue Off Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "Installment_Due_Paid_Off",
          label: "Installment Due Paid Off Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "FeeChargeRcvAmt",
          label: "Fee Charge Rcv Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "FeeChargeRcvPaidAmt",
          label: "Fee Charge Rcv Paid Amt",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "tenor",
          label: "Tenor",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NumofAsset",
          label: "Num of Asset",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "duedate",
          label: "Maturity Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "matauang",
          label: "Currency",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
      },
      {
          key: "NTFAmount",
          label: "NTF Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "InstallmentAmount",
          label: "Installment Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "LastPaymentDate",
          label: "Last Payment Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "OSAR",
          label: "OS AR",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "interest",
          label: "Interest Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "TotalAR",
          label: "Total AR",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "TotalOverdue",
          label: "Total Overdue (in days)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "730days",
          label: "7-30 days",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "3160days",
          label: "31-60 days",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "60days",
          label: ">60 days",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "MaxOverdue",
          label: "Max Overdue (Real)",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentAmount",
          label: "Next Installment Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentDate",
          label: "Next Installment Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentNumber",
          label: "Next Installment Number",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NextInstallmentDueDate",
          label: "Next Installment Due Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "NEXT_INST_DUE_NUM",
          label: "Next Installment Due Number",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      {
          key: "UCI_lancar",
          label: "UCI Amount",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
      },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  }, 

  async created() {
    this.model.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
    this.model.tgl2=moment(this.model.periode).endOf('month').format('YYYY-MM-DD');
    // .add(1,'M').subtract(1, 'day');
    console.log('this.model.periode',this.model.periode);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },     
    clearFilter() {
          //this.filterOn= []   
          this.filter= '';   
    } ,

    onChangeMonth: async function (){
        var tgl=this.model.periode;
        this.model.tgl2=moment(tgl).endOf('month').format('YYYY-MM-DD');
        this.$forceUpdate();
    }, 
    async getDA() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
            this.isBusy = true;
            const result = await pinjaman.DAreport_wo30sep19(this.model);
            this.tblData.items = result;
            this.tblData.total = result.length;
            this.isBusy = false;
        } catch (error) {
            this.isBusy=false;
            if (error.message) {
                toastr.error(error.message,'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error),'Error Info',10000);
            }
        }
       }

    },
    async exportxlsDA() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
      try {
        this.isBusy = true;
        await pinjaman.exportxlsDA_wo30sep19(this.model);
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
       }
    },
    close() {
      router.push("home");
    },
  },
};
</script>